import React from 'react';
import { isMobileDevice } from 'shared/utils';
import TextToDownload from '../textToDownload';
import AppleStoreIcon from 'images/apple-store-icon.png';
import GooglePlayIcon from 'images/google-play-icon.png';
import Text from 'components/ui/text';
import View from 'components/ui/view';
import scrollIntoView from 'scroll-into-view';

class PostSignup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { canDownloadApp: false };
  }

  componentDidMount() {
    this.setState({ canDownloadApp: isMobileDevice() });
    if (this.container) {
      const rect = this.container.getBoundingClientRect();
      if (rect && rect.top < 0) scrollIntoView(this.container);
    }
  }

  shopNow(e) {
    if (this.props.shopNow) {
      e.preventDefault();
      this.props.shopNow();
    }
  }

  render() {
    const message = this.props.message;
    const promoCodes = this.props.promoCodes || [];
    const promoCodeVal =
      promoCodes.length && !!promoCodes[0] ? promoCodes[0].val : null;

    return (
      <div ref={div => (this.container = div)}>
        {message === 'welcome' ? (
          <div className="text-center">
            <View padding={{ sides: 'md', top: 'md' }} margin="sm">
              <Text display tag="h1" size="xxl" weight="med" margin="none">
                Welcome to the Good Life
              </Text>
            </View>

            <View padding={{ sides: 'md', top: 'xs', bottom: 'xs' }}>
              <Text tag="p" size="md">
                Enjoy $10 off your first purchase with the code:{' '}
                <Text tag="span" weight="bold">
                  GOODLIFE18
                </Text>
              </Text>
            </View>

            <View padding="md" margin="sm">
              <a
                onClick={e => this.shopNow(e)}
                href="/"
                className="button btn-primary green"
              >
                Shop now
              </a>
            </View>

            <View padding={{ sides: 'md' }}>
              {this.state.canDownloadApp ? (
                <div>
                  <div className="divider-group">
                    <span className="divider-group__text">
                      Or Download the App
                    </span>
                    <div className="divider-group__divider" />
                  </div>
                  <View padding={{ bottom: 'lg' }}>
                    <div id="app-imgs">
                      <a href="https://app.adjust.com/vdebgr">
                        <img src={AppleStoreIcon} />
                      </a>
                      <a href="https://app.adjust.com/qxnd5g">
                        <img src={GooglePlayIcon} />
                      </a>
                    </div>
                  </View>
                </div>
              ) : (
                <div>
                  <div className="divider-group">
                    <span className="divider-group__text"> Or Get the App</span>
                    <div className="divider-group__divider" />
                  </div>
                  <View padding={{ sides: 'md', top: 'sm' }}>
                    <TextToDownload
                      section="Post-Signup Page"
                      className="text-to-download--wide"
                    />
                  </View>
                </div>
              )}
            </View>
          </div>
        ) : (
          <div className="text-center">
            <View padding={{ sides: 'md', top: 'md' }} margin="md">
              <Text display tag="h1" size="xxl" weight="med" margin="none">
                {message === 'not-new-user'
                  ? 'Welcome Back'
                  : 'Welcome to the Good Life'}
              </Text>

              {message === 'not-new-user' && (
                <p>
                  The promo code you entered is not valid for returning
                  customers. If you have another promo code, you can still enter
                  it at checkout 😉{' '}
                </p>
              )}

              {message === 'promo-invalid' && (
                <p>
                  The promo code you entered was not valid. If you have another
                  promo code, you can still enter it at checkout 😉{' '}
                </p>
              )}

              {message === 'promo-success' && (
                <p>
                  A {promoCodeVal ? `$${promoCodeVal}` : ''} credit has been
                  added to your account. The discount will be applied to your
                  cart at checkout. Cheers 😉{' '}
                </p>
              )}
            </View>

            <View padding={{ sides: 'md', bottom: 'md' }}>
              <a
                href="/"
                onClick={e => this.shopNow(e)}
                className="button btn-primary green"
              >
                Shop Now
              </a>
            </View>
          </div>
        )}
      </div>
    );
  }
}

export default PostSignup;



// WEBPACK FOOTER //
// ./shared/components/login/postSignup.js